import { FormControlLabel } from "@mui/material";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greenMui, greyMui, lightBlueMui, orangeMui } from "@ryde/theme";

import { RichViewLogsDrawerWrapperStyled } from "../rich-logs-components";

export const PriceRateSearchLogsDrawerWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "drawer-price-rate-search-logs-wrapper",
  },
)<{ $isRtl: boolean }>`
  ${RichViewLogsDrawerWrapperStyled}
  position: relative;
  min-height: 100%;
  padding: 16px;

  .log__filters-container {
    position: relative;
    z-index: 0;
    width: 100%;
  }

  .log__filters-container .log__filters-panel.log__collapsible-filter-section {
    background: #fff;
    border: 1px solid ${greyMui._200};
    border-radius: 10px;
    box-shadow: none;
  }

  .log__filters-container
    .log__filters-panel.log__collapsible-filter-section.collapsed {
    background: ${greyMui._50};
  }

  .log__filters-container
    .log__filters-panel.log__collapsible-filter-section
    .log__collapsible-filter-section__toggle {
    border-radius: 10px;
  }

  .log__item--time,
  .log__item--level,
  .log__item--step,
  .log__item--group {
    display: none;
  }

  .log__item {
    padding: 10px 12px;
  }

  .log__item--message {
    margin-top: 0;
  }

  .log__item--message .price-rate-search-winner-title {
    font-weight: 700;
    color: ${lightBlueMui._700};
  }

  .log__item--message .price-rate-search-final-recalc-total {
    font-weight: 700;
    color: ${lightBlueMui._700};
  }

  .price-rate-search-logs-header__filters-panel {
    background: #fff;
    border: 1px solid ${greyMui._200};
    border-radius: 10px;
    box-shadow: none;
  }

  .price-rate-search-logs-header__filters-panel.collapsed {
    background: ${greyMui._50};
  }

  .price-rate-search-logs-header__filters-panel-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 10px 10px;
  }
`;

export const PriceRateSearchLogsHeaderStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "price-rate-search-logs-header",
  },
)`
  position: sticky;
  top: 0;
  z-index: 30;
  isolation: isolate;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  margin: 0 0 12px;
  background: ${greyMui._50};
  border: 1px solid ${greyMui._200};
  border-radius: 12px;
  box-shadow: 0 8px 18px -14px rgba(0, 0, 0, 0.35);

  .price-rate-search-logs-header__top {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px 12px;
  }

  .price-rate-search-logs-header__modes.MuiToggleButtonGroup-root {
    background: #fff;
    border-radius: 8px;
  }

  .price-rate-search-logs-header__modes .MuiToggleButton-root {
    text-transform: none;
    font-weight: 600;
    padding: 4px 10px;
  }

  .price-rate-search-logs-header__actions {
    display: flex;
    align-items: stretch;
    flex-shrink: 0;
    gap: 8px;
  }

  .price-rate-search-logs-header__refresh-btn,
  .price-rate-search-logs-header__reset-btn {
    flex-shrink: 0;
    background: #fff;
    min-height: 32px;
    box-sizing: border-box;
  }

  .price-rate-search-logs-header__reset-btn {
    padding: 6px 10px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
    color: ${greyMui._700};
  }

  .price-rate-search-logs-header__result {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    background: ${greenMui._50};
    color: ${greenMui._800};
  }

  .price-rate-search-logs-header__result--empty {
    background: ${orangeMui._50};
    color: ${orangeMui._800};
  }

  .price-rate-search-logs-header__hint {
    margin: 0;
    font-size: 12px;
    line-height: 1.4;
    color: ${greyMui._700};
  }

  .price-rate-search-logs-header__search .MuiFormControl-root {
    margin-bottom: 0;
  }

  .price-rate-search-logs-header__filters {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .price-rate-search-logs-header__lock-row {
    display: grid;
    grid-template-columns: minmax(148px, 190px) minmax(0, 1fr);
    align-items: center;
    gap: 8px 12px;
    padding: 8px 10px;
    border-radius: 10px;
    background: #fff;
    border: 1px solid ${greyMui._200};
  }

  .price-rate-search-logs-header__lock-row--on {
    border-color: ${orangeMui._200};
    background: ${orangeMui._50};
  }

  .price-rate-search-logs-header__lock-row--switch-only {
    grid-template-columns: 1fr;
  }

  .price-rate-search-logs-header__lock-row .MuiInputBase-readOnly {
    background: ${greyMui._50};
  }

  .price-rate-search-logs-header__supplier-field,
  .price-rate-search-logs-header__vehicle-type-field {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .price-rate-search-logs-header__field-meta {
    font-size: 11px;
    line-height: 1.35;
    color: ${greyMui._600};
  }

  .price-rate-search-logs-header__field-meta--wrap {
    display: block;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .price-rate-search-rates {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .price-rate-search-rate-card {
    width: 100%;
    padding: 8px 10px 8px 8px;
    border-radius: 10px;
    background: #fff;
    border: 1px solid ${greyMui._200};
  }

  .price-rate-search-rate-card--info {
    background: #fff;
    border-color: ${greyMui._200};
  }

  .price-rate-search-rate-card--winner {
    border-color: ${greenMui._200};
    background: ${greenMui._50};
  }

  .price-rate-search-rate-card__main {
    display: block;
  }

  .price-rate-search-rate-card__info {
    min-width: 0;
    flex: 1;
    padding-inline-start: 0;
  }

  .price-rate-search-rate-card__top {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 6px 8px;
    margin-bottom: 4px;
    margin-inline-start: 0;
    padding-inline-start: 0;
  }

  .price-rate-search-rate-card__section-title {
    display: block;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.35;
    letter-spacing: normal;
    text-transform: none;
    color: ${greyMui._700};
  }

  .price-rate-search-rate-card__section-title--winner {
    color: ${greenMui._800};
  }

  .price-rate-search-named-inline {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0 4px;
  }

  .price-rate-search-rate-card__title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 4px 8px;
    margin-bottom: 2px;
    font-size: 13px;
    font-weight: 700;
    color: ${greyMui._800};
  }

  .price-rate-search-rate-card__title-text {
    font-weight: 700;
    color: ${greyMui._800};
  }

  .price-rate-search-rate-card__fact-label {
    color: ${greyMui._500};
    font-weight: 500;
  }

  .price-rate-search-rate-card__facts {
    font-size: 12px;
    line-height: 1.45;
    color: ${greyMui._700};
  }

  .price-rate-search-rate-card__price-line {
    margin-top: 6px;
    font-size: 12px;
    line-height: 1.45;
    color: ${greyMui._800};
  }

  .price-rate-search-rate-card__price-value {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
  }

  .price-rate-search-rate-card__price-details {
    color: ${greyMui._600};
    font-weight: 400;
  }

  .price-rate-search-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 1px 6px;
    border-radius: 999px;
    background: ${greyMui._50};
    border: 1px solid ${greyMui._200};
    font-size: 12px;
    font-weight: 600;
    line-height: 1.3;
    color: ${greyMui._800};
  }

  .price-rate-search-chip--id {
    font-weight: 700;
    color: ${lightBlueMui._700};
  }

  .price-rate-search-chip__id {
    font-weight: 500;
    color: ${greyMui._600};
  }

  .price-rate-search-chip__arrow {
    color: ${greyMui._500};
  }

  .price-rate-search-logs-header__entity-link {
    display: inline-flex;
    align-items: center;
    padding: 0;
    border: 0;
    background: none;
    font: inherit;
    color: ${lightBlueMui._700};
    text-decoration: none;
    cursor: pointer;
  }

  .price-rate-search-logs-header__entity-link:hover {
    text-decoration: underline;
  }

  .price-rate-search-logs-header__lock-hint {
    margin: 0;
    width: 100%;
    font-size: 11px;
    line-height: 1.35;
    color: ${greyMui._600};
  }

  .price-rate-search-autocomplete-option {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
    padding: 2px 0;
  }

  .price-rate-search-autocomplete-option--inline {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .price-rate-search-autocomplete-option__primary {
    font-size: 13px;
    font-weight: 500;
    line-height: 1.35;
    color: ${greyMui._800};
  }

  .price-rate-search-autocomplete-option__secondary {
    font-size: 11px;
    line-height: 1.35;
    color: ${greyMui._600};
  }

  .price-rate-search-autocomplete-option__id-chip {
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 700;
    color: ${lightBlueMui._700};
  }

  .price-rate-search-rate-card__fact-block {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    vertical-align: top;
  }

  .price-rate-search-rate-card__entity-meta {
    font-size: 11px;
    line-height: 1.35;
    color: ${greyMui._600};
    padding-inline-start: 0;
  }

  .price-rate-search-named-inline--id-first {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0 4px;
  }
`;

export const PriceRateSearchLockLabel = styled(FormControlLabel)`
  &.MuiFormControlLabel-root {
    margin-inline-start: 0;
    margin-inline-end: 0;
  }
`;
